import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_MASTER_SETTING = createActionTypes('FETCH_MASTER_SETTING');
export const GET_MASTER_SETTING = createActionTypes('GET_MASTER_SETTING');
export const UPDATE_MATER_SETTING = createActionTypes('UPDATE_MATER_SETTING');
